export const AUTHOR_PATH_PREFIX = '/blog/authors';

/**
 * Turns a display name into the URL segment the design asked for
 * ("Brian Munz" -> "brian-munz"). Diacritics are folded rather than dropped so
 * "Renée" becomes "renee" instead of "ren-e".
 */
export const slugifyAuthorName = (name?: Maybe<string>): string =>
  (name || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

/**
 * The slug an author's page lives at. The Builder `person` model has no slug
 * field, so the name is the source of truth and the optional `slug` field is
 * only there to pin a URL (duplicate names, a rename that must keep its link).
 */
export const getAuthorSlug = (author?: Maybe<AuthorReference>): string =>
  (author?.slug || '').trim() || slugifyAuthorName(author?.name);

/**
 * The public path for an author, or null when that author has no page.
 * Callers use the null to decide between rendering a byline as a link and
 * rendering it as plain text, so a name never links to a 404.
 */
export const getAuthorPath = (author?: Maybe<AuthorReference>): string | null => {
  if (!author?.authorPageEnabled) {
    return null;
  }

  const slug = getAuthorSlug(author);

  return slug ? `${AUTHOR_PATH_PREFIX}/${slug}/` : null;
};
